/* G Decor — friendly variant-required message */
(function(){
  'use strict';

  var FRIENDLY_MSG = 'Please select a Design first';
  var SHOPIFY_ERRORS = ['Cannot find variant', 'cannot find variant', 'Variant not found'];

  function showToast(msg) {
    var existing = document.getElementById('gd-variant-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'gd-variant-toast';
    toast.textContent = msg;
    toast.setAttribute('role', 'alert');
    toast.style.cssText = [
      'position:fixed','bottom:32px','left:50%','transform:translateX(-50%)',
      'background:#1B1714','color:#FBF6EC',
      'padding:14px 28px','border-radius:0',
      "font-family:'Inter',-apple-system,sans-serif",'font-size:13px','letter-spacing:0.06em',
      'z-index:99999','box-shadow:0 8px 32px rgba(0,0,0,0.25)',
      'max-width:90vw','text-align:center',
      'opacity:0','transition:opacity 0.25s ease'
    ].join(';');
    document.body.appendChild(toast);
    requestAnimationFrame(function(){ toast.style.opacity = '1'; });
    setTimeout(function(){
      toast.style.opacity = '0';
      setTimeout(function(){ if (toast.parentNode) toast.remove(); }, 300);
    }, 3500);
  }

  function isNoVariantError(text) {
    if (!text) return false;
    for (var i = 0; i < SHOPIFY_ERRORS.length; i++) {
      if (text.indexOf(SHOPIFY_ERRORS[i]) > -1) return true;
    }
    return false;
  }

  function hasVariantId(form) {
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return false;
    var v = (idInput.value || '').trim();
    if (!v || v === '0' || v === 'null' || v === 'undefined') return false;
    return true;
  }

  // Intercept ATC button clicks (capture phase so we run before theme handlers)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('button[name="add"], button.product-form__cart-submit, button.add-to-cart, [data-add-to-cart]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (hasVariantId(form)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    showToast(FRIENDLY_MSG);
  }, true);

  // Intercept form submissions as fallback
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (hasVariantId(form)) return;
    e.preventDefault();
    e.stopPropagation();
    showToast(FRIENDLY_MSG);
  }, true);

  // Intercept fetch responses for /cart/add.js errors
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function(){
      var args = arguments;
      var url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
      if (url.indexOf('/cart/add') > -1) {
        return originalFetch.apply(this, args).then(function(response){
          if (!response.ok) {
            var clone = response.clone();
            clone.json().then(function(data){
              var msg = (data && (data.description || data.message)) || '';
              if (isNoVariantError(msg)) {
                showToast(FRIENDLY_MSG);
                // Try to dismiss other error toasts
                setTimeout(function(){
                  document.querySelectorAll('*').forEach(function(el){
                    if (el.id === 'gd-variant-toast') return;
                    if (el.children.length > 0) return;
                    if (!el.textContent) return;
                    if (isNoVariantError(el.textContent)) {
                      if (el.parentNode) el.parentNode.style.display = 'none';
                    }
                  });
                }, 30);
              }
            }).catch(function(){});
          }
          return response;
        });
      }
      return originalFetch.apply(this, args);
    };
  }

  // Intercept XHR responses too (some themes use XHR for cart/add)
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url){
    this._gdUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(){
    var xhr = this;
    xhr.addEventListener('load', function(){
      if (xhr._gdUrl && xhr._gdUrl.indexOf('/cart/add') > -1 && xhr.status >= 400) {
        try {
          var data = JSON.parse(xhr.responseText);
          var msg = (data && (data.description || data.message)) || '';
          if (isNoVariantError(msg)) {
            showToast(FRIENDLY_MSG);
          }
        } catch(e){}
      }
    });
    return origSend.apply(this, arguments);
  };

  // Fallback: MutationObserver to catch any "Cannot find variant" rendered to DOM
  function scrubDOM(root){
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node){
        return isNoVariantError(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var t;
    while ((t = walker.nextNode())) {
      var parent = t.parentNode;
      while (parent && parent !== root) {
        if (parent.id === 'gd-variant-toast') break;
        parent = parent.parentNode;
      }
      // Replace text content
      t.nodeValue = t.nodeValue
        .replace(/Cannot find variant/gi, FRIENDLY_MSG)
        .replace(/Variant not found/gi, FRIENDLY_MSG);
    }
  }

  var observer = new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(n){
        if (n.nodeType === 1) scrubDOM(n);
      });
    });
  });
  document.addEventListener('DOMContentLoaded', function(){
    observer.observe(document.body, { childList: true, subtree: true });
    scrubDOM(document.body);
  });
})();
